import Cookies from "js-cookie";

function getNestedValue(obj: unknown, path: string[]): unknown {
    return path.reduce(
        (acc, key) => (acc && typeof acc === "object" && acc !== null && key in acc ? (acc as Record<string, unknown>)[key] : undefined),
        obj
    );
}

export const getValueFromBrowserStorage = (
    source: string,
    key: string,
    shouldCapitalize: boolean = false
): string => {
    if (
        source === "None" ||
        key === "None" ||
        !source ||
        !key
    ) {
        return "";
    }

    const keyParts = key.split(".");
    const rootKey = keyParts[0];
    const nestedPath = keyParts.slice(1);

    let rawValue: string | undefined;

    switch (source) {
        case "localStorage":
            rawValue = localStorage.getItem(rootKey) || "";
            break;
        case "sessionStorage":
            rawValue = sessionStorage.getItem(rootKey) || "";
            break;
        case "Cookies":
            rawValue = Cookies.get(rootKey) || "";
            break;
        default:
            return "";
    }

    if (!rawValue) return "";

    let value: unknown = rawValue;

    // If there is a nested path, try to parse as JSON and traverse
    if (nestedPath.length > 0) {
        try {
            value = JSON.parse(rawValue);
            value = getNestedValue(value, nestedPath);
        } catch {
            return "";
        }
    }

    if (shouldCapitalize) {
        return typeof value === "string" ? value.toUpperCase() : "";
    }

    return typeof value === "string" ? value : "";
};